
<!--<div class="uofs-page layout-homepage">-->
<!--    <div class="is-flex">-->
<!--        <div class="col-lg-2 col-md-3 col-sm-3 col-xs-0" [class.hidden]="!isLoggedIn()">-->
<!--            <div class="uofs-offcanvas">-->
<!--                <app-navigation></app-navigation>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-lg-10 col-md-9 col-sm-9 col-xs-12 layout-content">-->
<!--            <div id="content" class="uofs-page-content">-->
<main id="content bg-white" tabindex="-1" class="">

<div class="border-bottom content-header" [class.bg-paws-header]="state!='visible'" [class.header-bg-warning]="state=='visible'">
    <h1 class="d-inline-flex pe-3 mb-0">{{ channeltitle }}</h1>
    @if ( showIframe && !isHidden ) {
        <div class="portlet-options d-inline-block align-top mt-1">
           <!-- <a class="btn btn-sm btn-default portlet-add" title="Add to Favourites" href="#" style="display: none;"><i class="fa fa-star text-muted"></i> Add to Favourites</a>
            <a class="btn btn-sm btn-warning portlet-remove" title="Remove from Favourites" href="#" style="display: none;"><i class="fa fa-star"></i> <span>Remove from </span>Favourite<span>s</span></a>
            -->
            @if ( !isChannelFavorite && !isIcon && !isMyCollege ) {
                <button class="btn btn-outline-secondary mb-1" title="Add to Favourites" (click)="addFavorite()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                        <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                    </svg>
                    <span class="d-none d-sm-inline-block">&nbsp;Add to Favourites</span></button>
            }
            @if ( isChannelFavorite && !isIcon && !isMyCollege ){
                <button class="btn btn-outline-primary mb-1" title="Remove from Favourites" (click)="deleteFavorite()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <span class="d-none d-sm-inline-block">&nbsp;Remove from Favourites</span>
                </button>
            }
        </div>
    }
    @if ( state == 'visible' ) {
        <p class="mb-0 mt-2 fs-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
            </svg>
            You are viewing a student channel. You may have limited access to some content.
        </p>
    }
</div>
<div class="bg-white content-body">
    @if ( getShowBackBtn ) {
        <div class="backWrapper" id="backWrapper">
            <button class="btn btn-primary" [routerLink]="['/',currentChannel.goname]">BACK TO CHANNEL</button>
        </div>
    }
    @if ( hasBreadcrumbs() && subpage && currentChannel != null && subPageTitle != null ){
        <div class="mb-4">
            <a [routerLink]="['/',currentChannel.goname]" aria-label="back to channel homepage" class="fw-bold">{{ channeltitle }}</a>
            @if ( subFolderTitle != null ) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right ms-2 me-1" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                </svg>
                {{ subFolderTitle }}
            }
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right ms-2 me-1" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
            </svg>
            {{ subPageTitle }}
        </div>
    }
    @if ( state=='not_found' ) {
        <div class="backgroundMask text-center">
            <div class="alert alert-warning" role="alert">
                <div class="h2">Not Found</div>
                <div class="mt-3 h5">This can happen if the URL is not correct. Check the <a [routerLink]="['/search']">Apps & Services</a> page.</div>
                <div class="mt-3 h5">This could also be because you do not have permission to access this channel. You can contact <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> for help.</div>
            </div>
        </div>
    }
    @if ( state=='ineligible' ) {
        <div class="backgroundMask text-center">
            <div class="alert alert-info" role="alert">
                <div class="h2">Access Denied</div>
                <div class="mt-3 h5">You do not currently have permission to see this channel. </div>
<!--                <div class="mt-3"></div>-->
               <div class="mt-3 h5">If you think you should have access, you can contact <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> for help. Please include the channel title above.</div>
                <!-- @if ( accessRequestStatus == 'notsent' ) {
                    <div class="mt-3 h5">If you think you should have access, click 'Submit Support Request'.<br/> A support request will be sent to <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> on your behalf.</div>
                    <div class="mt-3 h5"><button class="btn btn-lg btn-primary" (click)="requestAccess()">Submit Support Request</button></div>
                } @else if ( accessRequestStatus == 'sending' ) {
                    <div class="mt-3 h5">Sending your request. Please wait ... </div>
                    <div class="h5 text-muted">
                        <div class="spinner-border ms-2" role="status"><span class="visually-hidden">Loading...</span></div>
                    </div>
                } @else if ( accessRequestStatus == 'sent' ) {
                    <div class="mt-3 h5">Your request has been sent to PAWS Support team. We will respond as soon as we can.</div>
                } @else if ( accessRequestStatus == 'error' ) {
                    <div class="mt-3 h5">There was a problem sending this for you. Please contact <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> for help.</div>
                } -->
    <!--            <p><strong>Eligible Users: </strong> {{ currentChannel.eligibility }}</p>-->
            </div>
        </div>
    }
    @if ( state=='loading_error' ) {
        <div class="backgroundMask text-center">
            <div class="alert alert-danger" role="alert">
                <div class="h2">Error</div>
                <div class="mt-3 h5">There was a problem loading this channel. </div>
                <div class="mt-3 h5">If you followed a link to this page, you can look for the channel in the <a [routerLink]="['/search']">Apps & Services</a> page.</div>
                <div class="mt-3 h5">Otherwise, this channel could be experiencing technical issues. Please contact <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> for help.</div>
            </div>
        </div>
    }
    @if ( state=='loading' ) {
        <div class="backgroundMask text-center" id="loading-wrapper">
            <div class="h5 text-muted">
                <div class="spinner-border ms-2" role="status"><span class="visually-hidden">Loading...</span></div>
            </div>
        </div>
    }
    @if ( showLNANotice ) {
        <div class="alert alert-info" role="alert">
            <div class="row">
                <div class="col-lg-8">
                    <div class="h2">Set Local Network Access for PAWS</div>
                    <div>A recent update to Google Chrome has added extra security around access to devices on your local network. You may see a prompt asking to <strong>Look for and connect to any device on your local network.</strong>.</div>
                    <div class="mt-4 h5">PAWS is a centrally supported service for use by USask employees and can be trusted.<br />If you see this prompt, please choose Allow.
                    </div>
                </div>
                <div class="col text-end">
                    <p class="btn btn-link" (click)="toggleLNAImgWidth()">
                    <img src="assets/img/paws-lna-permission.png" class="img-fluid img-thumbnail" style="max-width:{{lnaWidth}};" />
                    </p>
                </div>
            </div>
        </div>
    }
        <iframe
            type="text/html"
            class="{{ state }}"
            [src]="channelURL | safeUrl"
            (load)="iframeLoaded()"
            (error)="iframeError()"
            width="100%"
            height="75vh"
            id="iframeChannel"
            name="iframeChannel"
            allow="local-network-access"
        ></iframe>

</div>
</main>
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
